import Vue from 'vue';
import Router from 'vue-router';
import UserSession from '@/store/UserSession';
import Excel2BP from '@/views/Excel2BP';

Vue.use(Router);

const SEDE_PATTERN = "/sede/:sede";  // centro url
const CORP_PATTERN = "/corp/:corp";  // enterprise url

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/About.vue'),
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${SEDE_PATTERN}/about`,
      name: 'sedeabout',
      component: () => import('@/views/About.vue'),
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${SEDE_PATTERN}`,
      // Redirect: /sede/misede → /sede/misede/login
      redirect: to => {
        return { path: `/sede/${to.params.sede}/login` };
      },
    },
    {
      path: `${SEDE_PATTERN}/login`,
      name: 'sedelogin',
      component: () => import('./views/Login.vue'),
    },
    {
      path: `${CORP_PATTERN}/about`,
      name: 'corpabout',
      component: () => import('@/views/About.vue'),
      beforeEnter() {location.href = 'https://www.kmkey.com/'}
    },
    {
      path: `${CORP_PATTERN}`,
      // Redirect: /sede/misede → /sede/misede/login
      redirect: to => {
        return { path: `/corp/${to.params.corp}/login` };
      },
    },
    {
      path: `${CORP_PATTERN}/login`,
      name: 'corplogin',
      component: () => import('./views/Login.vue'),
    },
    {
      path: `/login`,
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '*/logout',
      name: 'logout',
      component: () =>
        import(/* webpackChunkName: "logout" */ './views/Logout.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ssologin',
      name: 'ssologin',
      beforeEnter: () => location.assign(Vue.config.SSO.loginURL)
    },
    {
      path: '/ssocallback',
      name: 'ssocallback',
      component: () => import('./views/SSOCallback.vue')
    },
    {
      path: '*/ssologout',
      name: 'ssologout',
      beforeEnter: () => location.replace(Vue.config.SSO.logoutURL)
    },
    {
      path: '*/processes',
      name: 'processes',
      component: () =>
        // import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/processes_old',
      name: 'processes_old',
      component: () =>
         import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        //import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },    
    {
      path: '*/preferences',
      name: 'preferences',
      component: () =>
        import(/* webpackChunkName: "preferences" */ './views/Preferences.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/roles',
      name: 'roles',
      component: () => import('@/views/Roles'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/aiadmin',
      name: 'aiadmin',
      component: () => import('@/views/AIAdmin'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },

    {
      path: '*/sites',
      name: 'sites',
      component: () => import('@/views/Sites'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/centros',
      name: 'centros',
      component: () => import('@/views/Centros'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/risk_matrix',
      name: 'risk_matrix',
      component: () => import('@/views/RiskMatrixAdmin'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/users',
      name: 'users',
      component: () => import('@/views/Users'),
      meta: {
        requiresAuth: true,
        admin: true,
        manager: true,
      },
    },
    {
      path: '*/locations',
      name: 'locations',
      component: () => import('@/views/Locations'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/explorer',
      name: 'explorer',
      component: () => import('@/views/GenericExplorerView'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/explorerCalendar',
      name: 'explorerCalendar',
      component: () => import('@/components/explorer/ExplorerCalendar'),
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '*/menus',
      name: 'menus',
      component: () => import('@/views/Menus'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/directories',
      name: 'directories',
      component: () => import('@/views/Directories'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/vocabularies',
      name: 'vocabularies',
      component: () => import('@/views/Vocabulary'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: '*/pdf',
      name: 'pdf',
      component: () => import('@/views/PDFViewer'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/todoList',
      name: 'todoList',
      component: () => import('@/views/TodoListView'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*/search',
      name: 'search',
      component: () => import('@/components/explorer/GlobalSearch'),
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '*/bpexplorertable',
      name: 'BPExplorerTable',
      component: () => import('@/components/bpexplorer/BPExplorerTable'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      // will match everything
      path: '*',
      component: () => import('@/views/404'),
    },
    {
      path: '*/excel2bp',
      name: 'excel2bp',
      component: () => import('@/views/Excel2BP'),
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '*/bpplayground',
      name: 'bp',
      component: () => import('@/views/BPCreator'),
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  router.app.$nextTick(()=>{
    if (!!to.meta.requiresAuth && !(UserSession.state.user && UserSession.state.user.id)) {
      // Redirected to login
      let login = { path: '/login', query: { redirect: to.fullPath }, };
      if (to.params.pathMatch) {
        login.path = to.params.pathMatch;
      }
      next(login);
    } else {
      //  Check permissions and move
      if (user_permission(to,UserSession.state.user)) {
        next();
      } else {
        next(from);
      }
    }
  })
});

function user_permission(view, user) {
  if (!user.id) {
    return !view.meta.requiresAuth;
  } else if(user.isAdmin && view.name != 'login') {
    return true;
  }
  // Logged users cannot go to login
  return (view.name != 'login') && (!view.meta.admin && !view.meta.manager) || view.meta.manager && user.isManager;
}

export default router;
